import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import { RootState } from 'src/app/reducers';
import { openWindow } from '../../../../actions/core.actions';
import { NEW_INSTALLATION_URL, OTHER_INQUIRY_URL, UNIVERSITY_INQUIRY_URL } from '../../../../resources/config';

@Component({
  selector: 'app-installation-dialog',
  templateUrl: './installation-dialog.component.html',
  styleUrls: ['./installation-dialog.component.scss']
})
export class InstallationDialogComponent {
  newInstallationUrl: string = NEW_INSTALLATION_URL;
  otherInquiryUrl: string = OTHER_INQUIRY_URL;
  universityInquiryUrl = UNIVERSITY_INQUIRY_URL;

  constructor(private store: Store<RootState>, private dialogRef: MatDialogRef<InstallationDialogComponent>) {}

  onHighSchoolClick() {
    this.store.dispatch(openWindow({ url: this.newInstallationUrl }));
    this.dialogRef.close();
  }

  onCramSchoolClick() {
    this.store.dispatch(openWindow({ url: this.otherInquiryUrl }));
    this.dialogRef.close();
  }

  onUniversityClick() {
    this.store.dispatch(openWindow({ url: this.universityInquiryUrl }));
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}
